import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsx("path", { fill: "#ffb300", d: "M22.5 12A10.5 10.5 0 0 1 12 22.5 10.5 10.5 0 0 1 1.5 12a10.5 10.5 0 0 1 21 0" }),
  /* @__PURE__ */ s.jsx("path", { fill: "#ff8f00", d: "M20.25 12A8.25 8.25 0 0 1 12 20.25 8.25 8.25 0 0 1 3.75 12a8.25 8.25 0 0 1 16.5 0" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "m12.316 7.249 1.316 2.666 2.942.427a.352.352 0 0 1 .195.6l-2.128 2.075.503 2.93a.352.352 0 0 1-.511.371L12 14.935l-2.631 1.384a.352.352 0 0 1-.511-.371l.503-2.93-2.129-2.075a.352.352 0 0 1 .195-.6l2.942-.427 1.316-2.666a.352.352 0 0 1 .631 0z",
      fill: "#eceff1"
    }
  )
] });
export {
  l as T
};
